import React, { HTMLAttributes } from 'react';
import c from 'classnames';
import s from './InputErrorMessage.scss';

interface Props extends HTMLAttributes<HTMLSpanElement> {
  className?: string;
}

/**
 * An error message! Meant to follow an input field.
 */
const InputErrorMessage: React.FC<Props> = ({ children, className, ...rest }) => {
  return (
    <span
      className={c(s['root'], className)}
      // To notify screen reader users of what happened
      aria-live="assertive"
      {...rest}
    >
      {children}
    </span>
  );
};
InputErrorMessage.displayName = 'InputErrorMessage';

export default InputErrorMessage;
